module.exports = __webpack_public_path__ + "static/img/1.470127c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/1.jpg
// module id = 1703
// module chunks = 9